<script>
export default {
  name: "OpenFlexureHeader",
  props: {},
};
</script>
<template>
  <header class="site-header">
    <div class="wrapper">
      <a class="site-title" href="https://openflexure.org"
        ><span class="semibold">open</span>
        <span>flexure</span>
        <span class="light">.org</span></a
      >

      <nav class="site-nav">
        <a href="#" class="menu-icon" aria-label="Main menu">
          <svg viewBox="0 0 18 15">
            <path
              fill="#424242"
              d="M18,1.484c0,0.82-0.665,1.484-1.484,1.484H1.484C0.665,2.969,0,2.304,0,1.484l0,0C0,0.665,0.665,0,1.484,0 h15.031C17.335,0,18,0.665,18,1.484L18,1.484z"
            ></path>
            <path
              fill="#424242"
              d="M18,7.516C18,8.335,17.335,9,16.516,9H1.484C0.665,9,0,8.335,0,7.516l0,0c0-0.82,0.665-1.484,1.484-1.484 h15.031C17.335,6.031,18,6.696,18,7.516L18,7.516z"
            ></path>
            <path
              fill="#424242"
              d="M18,13.516C18,14.335,17.335,15,16.516,15H1.484C0.665,15,0,14.335,0,13.516l0,0 c0-0.82,0.665-1.484,1.484-1.484h15.031C17.335,12.031,18,12.696,18,13.516L18,13.516z"
            ></path>
          </svg>
        </a>

        <div class="trigger">
          <div class="dropdown">
            <a class="dropbtn page-link" href="#">Projects</a>

            <div class="dropdown-content">
              <a
                class="page-link"
                href="https://openflexure.org/projects/microscope/"
                >Microscope</a
              >

              <a
                class="page-link"
                href="https://openflexure.org/projects/blockstage/"
                >Block Stage</a
              >

              <a
                class="page-link"
                href="https://openflexure.org/projects/deltastage/"
                >Delta Stage</a
              >
            </div>
          </div>

          <a class="page-link" href="https://openflexure.org/downloads"
            >Downloads</a
          >

          <a class="page-link" href="https://openflexure.org/about">About</a>

          <div class="dropdown">
            <a class="dropbtn page-link" href="#">Community</a>

            <div class="dropdown-content">
              <a class="page-link" href="https://openflexure.org/contribute"
                >Contribute</a
              >

              <a class="page-link" href="https://openflexure.org/conduct"
                >Conduct</a
              >
            </div>
          </div>

          <a class="page-link" href="https://openflexure.org/blog">Latest</a>
        </div>
      </nav>
    </div>
  </header>
</template>

<style scoped>
.site-header {
  font: 400 16px/1.5 "Open Sans", sans-serif;
}

.dropdown-content {
  z-index: 2;
}

.site-nav {
  z-index: 2;
}

.page-link {
  font-size: 16px !important;
  font-face: ;
}
</style>
